module.exports = __webpack_public_path__ + "static/fonts/Mont-LightItalic.6a50db7.woff2";